module.exports = __webpack_public_path__ + "img/about.9a3bc255.png";